import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from 'shared/auth/auth.guard';
import { SubscriptionGuard } from 'shared/subscription/subscription.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { GetStartedComponent } from './get-started.component';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'get-started',
        canActivate: [AuthGuard],
        component: GetStartedComponent,
        resolve: { permissions: PermissionsResolver },
      },
    ])
  ],
  exports: [RouterModule],
  providers: [],
})
export class GetStartedRoutingModule {}
